import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { RevealSection, RevealCard } from '../Animations';
import { blogPosts } from '../../data/blogData';

const LatestInsights = () => {
  return (
    <section id="insights" className="section-padding relative">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12 md:mb-16">
          <RevealSection className="max-w-2xl">
            <span className="eyebrow">05. Insights</span>
            <div className="mt-3 mb-8 h-px bg-white/10" />
            <h2 className="text-[clamp(2rem,4.5vw,3.5rem)] font-display font-semibold text-white leading-[1.05] tracking-[-0.03em] mb-5">
              Latest thinking
            </h2>
            <p className="text-[17px] text-zinc-400 leading-[1.65]">
              Expert perspectives on AI automation, workflow optimization, and the future of business technology.
            </p>
          </RevealSection>
          <Link
            to="/blog/"
            className="btn-secondary self-start md:self-auto"
            aria-label="View all insights"
          >
            View all insights
            <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {blogPosts.slice(0, 3).map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}/`}
              className="group block"
              aria-label={`Read blog post: ${post.title}`}
            >
              <RevealCard className="h-full rounded-[var(--radius-lg)] bg-[color:var(--color-surface-1)] border border-white/10 hover:border-white/25 transition-colors overflow-hidden flex flex-col">
                <div className="aspect-[16/10] overflow-hidden border-b border-white/5">
                  <img
                    src={post.image}
                    alt={`Emerge Automations Insight: ${post.title} - AI Automation Trends 2026`}
                    className="w-full h-full object-cover grayscale-[0.2] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                    width="400"
                    height="250"
                    referrerPolicy="no-referrer"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <span className="eyebrow eyebrow--accent mb-4">
                    {post.category}
                  </span>
                  <h3 className="text-lg font-semibold text-white leading-[1.3] tracking-[-0.01em] mb-3 line-clamp-2 group-hover:text-[color:var(--color-accent)] transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-zinc-400 leading-relaxed mb-5 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="mt-auto flex items-center justify-between text-sm font-medium text-white pt-4 border-t border-white/5">
                    <span>Read post</span>
                    <ArrowUpRight
                      className="w-4 h-4 text-zinc-500 group-hover:text-[color:var(--color-accent)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                      strokeWidth={1.75}
                    />
                  </div>
                </div>
              </RevealCard>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestInsights;
